import React, { useEffect } from "react";

const AccessibeWidget = () => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://acsbapp.com/apps/app/dist/js/app.js";
    script.async = true;
    script.onload = () => {
      window.acsbJS.init({
        statementLink: "",
        footerHtml: "",
        hideMobile: false,
        hideTrigger: false,
        disableBgProcess: false,
        language: "en",
        position: "left",
        leadColor: "#146ff8",
        triggerColor: "#bb0000",
        triggerRadius: "50%",
        triggerPositionX: "left",
        triggerPositionY: "bottom",
        triggerIcon: "people",
        triggerSize: "medium",
        triggerOffsetX: 20,
        triggerOffsetY: 20,
        mobile: {
          triggerSize: "small",
          triggerPositionX: "left",
          triggerPositionY: "bottom",
          triggerOffsetX: 10,
          triggerOffsetY: 10,
          triggerRadius: "50%"
        }
      });
    };
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return null;
};

export default AccessibeWidget;